import { useState } from "react";
import PurchaseForm, {
  PurchaseFormData,
  PurchaseFormOptions,
} from "../../forms/PurchaseForm";
import { EMPTY_PURCHASE } from "../../forms/utils";
import CoreModal from "../CoreModal";
import { CoreAddModalProps } from "../ShipmentModals/AddShipmentModal";

interface AddShipmentModalProps
  extends CoreAddModalProps<PurchaseFormData, PurchaseFormOptions> {}

export const AddPurchaseModal: React.FC<AddShipmentModalProps> = ({
  open,
  onCancel,
  onSaveData,
  onBack,
  options,
}) => {
  const [draft, setDraft] = useState<PurchaseFormData>(EMPTY_PURCHASE);
  const handleSave = () => onSaveData?.([draft]);

  return (
    <CoreModal
      open={open}
      onCancel={onCancel}
      title="Add Purchase Order"
      backButton={onBack}
      onSave={handleSave}
      width={1000}
      maskClosable={false}
    >
      <PurchaseForm data={draft} onChange={setDraft} options={options} />
    </CoreModal>
  );
};

export default AddPurchaseModal;
